import React, { useEffect } from 'react';
import { requestToken, tokenValidation, addData, setData } from '@/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Spin } from 'antd';
import ResetPassword from './reset-password';
import { notification } from 'antd';

const EmailCodeForm = ({ email }) => {
  const [tokenCode, setTokenCode] = React.useState('');

  useEffect(() => {
    clearState();
  }, []);

  const dispatch = useDispatch();
  const otp = useSelector((state: any) => state?.auth?.tokenValidation);
  const tokenRequested = useSelector((state: any) => state?.auth?.tokenRequested);
  const otpLoading = otp?.loading;

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      email: email,
      token: tokenCode,
    };
    dispatch(tokenValidation(data));
  };

  useEffect(() => {
    if (tokenRequested?.status) {
      notification.success({ message: 'Code is send Successfully!' });
    }
  }, [tokenRequested?.status]);

  const clearState = () => {
    dispatch(
      addData({
        key: 'tokenValidation',
        value: {},
      })
    );
    dispatch(
      setData({
        name: 'tokenValidation',
        key: 'status',
        value: false,
      })
    );
  };

  const resendRequest = () => {
    dispatch(requestToken({ email: email }));
  };

  const handleTokenChange = (e) => {
    clearState();
    const { value } = e.target;
    const message = value.slice(0, 5);
    setTokenCode(message);
  };

  return (
    <>
      {otp?.status ? (
        <ResetPassword token={tokenCode} />
      ) : (
        <Spin spinning={otpLoading ? true : false}>
          <div className="main-banner mb-5">
            <div className="m-auto">
              <div className="validate-otp-form">
                <div className="title">
                  <h3 className="text-secondary font-weight-normal">
                    Confirmation Code
                  </h3>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    {/* <label htmlFor="otp_code"> */}
                    <div className="label-otp text-center">
                      We’ve sent a five-digit confirmation code to{' '}
                      <u className="font-weight-bold text-danger">{email}</u>. Enter
                      it below to confirm your email address.
                    </div>
                    <input
                      className="form-control max-auto"
                      id="otp_code"
                      onChange={(e) => handleTokenChange(e)}
                      type="number"
                      value={tokenCode}
                    />
                  </div>

                  {otp?.error?.token ? (
                    <label className="validation mx-auto text-danger">
                      <i className="fas fa-exclamation-triangle"></i>{' '}
                      {otp?.error?.token}
                    </label>
                  ) : (
                    ''
                  )}

                  {otp?.error?.status ? (
                    <label className="validation mx-auto text-danger">
                      <i className="fas fa-exclamation-triangle"></i>{' '}
                      {otp?.error?.status}
                    </label>
                  ) : (
                    ''
                  )}

                  <div className="text-center">
                    <Button
                      htmlType="submit"
                      className="btn-secondary border-danger w-75"
                    >
                      Verify
                    </Button>
                  </div>
                </form>

                <p className="mt-3 resend-button">
                  Not got Code?
                  <a className="text-danger" onClick={() => resendRequest()}>
                    {' '}
                    Resend
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Spin>
      )}
    </>
  );
};

export default EmailCodeForm;
